import React from 'react'

const Akkord = (props) =>{

    let akkordname = props.akkord.name_de
    if (props.language !=="de"){
        akkordname = props.akkord.name_en
    }

    let backimg =  <img src="/assets/images/gitarre-griffbrett-1.png" alt="" style={{position: 'absolute', left:'0', top: '0', width: '135px', height: '235px'}} />
    if (props.akkord.lage > 1){
        backimg =  <img src="/assets/images/gitarre-griffbrett-2.png" alt="" style={{position: 'absolute', left:'0', top: '0', width: '135px', height: '235px'}} />
    }
    let barree = null;
    if (props.akkord.barree === 1){
        barree = <div className="barree" />
    }

    let img_src_saite_1 =  null
    let img_src_saite_2 =  null
    let img_src_saite_3 =  null
    let img_src_saite_4 =  null
    let img_src_saite_5 =  null
    let img_src_saite_6 =  null

    let editButton = null
    if (props.editButton !== undefined) editButton = props.editButton

    function getRomanNumber(value){
        let ret = "II"
        switch (value){
            case 3:
                ret = "III"
            break;
            case 4:
                ret = "IV"
            break;
            case 5:
                ret = "V"
            break;
            case 6:
                ret = "VI"
            break;
            case 7:
                ret = "VII"
            break;
        }
        return ret
    }

   
    if (props.akkord.bund_saite1 !== "0"){
        img_src_saite_1 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite1}.png`}  alt="" className={`saite1-bund-${props.akkord.bund_saite1}`} />
        
        if (props.akkord.bund_saite1 === "-"){
            img_src_saite_1 =<img src="/assets/images/saite-daempfen.png" className="saite-daempfen"  alt="" style={{left:'104px'}} />
        }
    }
    if (props.akkord.bund_saite2 !== "0"){
        img_src_saite_2 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite2}.png`}  alt="" className={`saite2-bund-${props.akkord.bund_saite2}`} />
        
        if (props.akkord.bund_saite2 === "-"){
            img_src_saite_2 =<img src="/assets/images/saite-daempfen.png" className="saite-daempfen"  alt="" style={{left:'84px'}} />
        }
    }
    if (props.akkord.bund_saite3 !== "0"){
        img_src_saite_3 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite3}.png`}  alt="" className={`saite3-bund-${props.akkord.bund_saite3}`} />
        
        if (props.akkord.bund_saite3 === "-"){
            img_src_saite_3 =<img src="/assets/images/saite-daempfen.png"  alt="" className="saite-daempfen" style={{left:'65px'}} />
        }
    }
    if (props.akkord.bund_saite4 !== "0"){
        img_src_saite_4 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite4}.png`}  alt="" className={`saite4-bund-${props.akkord.bund_saite4}`} />
        
        if (props.akkord.bund_saite4 === "-"){
            img_src_saite_4 =<img src="/assets/images/saite-daempfen.png"  alt="" className="saite-daempfen" style={{left:'47px'}} />
        }
    }
    if (props.akkord.bund_saite5 !== "0"){
        img_src_saite_5 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite5}.png`}  alt="" className={`saite5-bund-${props.akkord.bund_saite5}`} />
        
        if (props.akkord.bund_saite5 === "-"){
            img_src_saite_5 =<img src="/assets/images/saite-daempfen.png"  alt="" className="saite-daempfen" style={{left:'27px'}} />
        }
    }
    if (props.akkord.bund_saite6 !== "0"){
        img_src_saite_6 = <img src={`/assets/images/gitarre-punkt-${props.akkord.finger_saite6}.png`}  alt="" className={`saite6-bund-${props.akkord.bund_saite6}`} />
        
        if (props.akkord.bund_saite6 === "-"){
            img_src_saite_6 =<img src="/assets/images/saite-daempfen.png"  alt="" className="saite-daempfen" style={{left:'7px'}} />
        }
        
    }

    let img_lage = null
    if (props.akkord.lage > 1){
       
        img_lage = <div className="lage" style={{top:'25px', zIndex:'8'}}><big>{getRomanNumber(props.akkord.lage)}</big></div>
    }

    let checkbox = null
    if (props.isLoggedIn){
        checkbox=(
            <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" onChange={props.changeAkkordeIds} value={props.akkord.id} role="switch" id="flexSwitchCheckDefault" checked={props.isUserChord(props.akkord.id)} />
            <label className="form-check-label" for="flexSwitchCheckDefault">{props.getString('$STR_0224')}</label>
            </div>
        )
    }

   


    return(
        <>
            <div style={{position: 'relative', width: '135px', marginTop:'25px'}}>
                <h4>{akkordname}</h4>
                {checkbox} {editButton}
            </div>      
            
       
            <div style={{position: 'relative', width: '135px', height: '235px', }}>
                {backimg}
                {barree}
                {img_src_saite_1}
                {img_src_saite_2}
                {img_src_saite_3}
                {img_src_saite_4}
                {img_src_saite_5}
                {img_src_saite_6}

                {img_lage}


            </div>
        </>
    )
}

export default Akkord;